module.exports = __webpack_public_path__ + "static/@1x-ophthalmology-xs-971b78b7bd0cd057dfe6ddfdca438ace.jpg";